import React, { useRef } from "react";

const TextInput = props => {
    const inputEl = useRef(null);
    const [showError, setShowError] = React.useState(false);
    const inputClassName = props.inputClassName ? "cdx-input " + props.inputClassName : "cdx-input";
    const className = props.className ? "cdx-form-group " + props.className : "cdx-form-group";

    const handleError = () => {
        setShowError(true);
        inputEl.current.setCustomValidity(" ");
        props.hasError && props.hasError(true);
    };

    const clearErrorMessage = () => {
        setShowError(false);
        inputEl.current.setCustomValidity("");
        props.hasError && props.hasError(false);
    };
    return (
        <div className={className}>
            {props.label && <label className="cdx-inpput-label">{props.label}</label>}
            <div className="cdx-input">
                <input
                    {...props}
                    ref={inputEl}
                    className={`${inputClassName} ${props.readOnly ? "readonlyInput" : ""}`}
                    onChange={(e) => { props.onChange(e); clearErrorMessage(); }}
                    onInvalid={handleError} />
            </div>
            {showError && <div className="error-msg">{props.errorText ? props.errorText : "Invalid Input"}</div>}
        </div>
    );
};
export default TextInput;